// import Swal from "sweetalert2";

import { isEmptyObjectOrArray, isValidData } from "./DataValidationUtils";

export function getFormattedNumber(num) {
  if (num && num.length > 0) {
    if (num.startsWith('91') && num.length === 12) {
      num = num.slice(2);
    } else if (num.startsWith('+91') && num.length === 13) {
      num = num.slice(3);
    } else if (num.length !== 10) {
      num = null;
    }

    if (num && /[0-9]{10}/.test(num)) {
      return num;
    } else {
      return null;
    }
  } else {
    return null;
  }
}

export const dollarIndianLocale = Intl.NumberFormat('en-IN');

export function humanReadableNumber(number, decPlaces = 0) {
  decPlaces = Math.pow(10, decPlaces);
  const abbrev = ["K", "M", "B", "T"];

  for (let i = abbrev.length - 1; i >= 0; i--) {
    let size = Math.pow(10, (i + 1) * 3);

    if (size <= number) {
      number = Math.round(number * decPlaces / size) / decPlaces;

      if ((parseInt(number) === 1000) && (i < abbrev.length - 1)) {
        number = 1;
        i++;
      }

      number += abbrev[i];
      break;
    }
  }
  return number;
}

export function formatToIndianCurrency(amt, minimumFractionDigits = 0) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: minimumFractionDigits }).format(amt)
}

export function getObjectKeys(ob) {
  if (isEmptyObjectOrArray(ob) || !isValidData(ob)) {
    return [];
  } else return Object.keys(ob);
}

export const colorDetect = (status) => {
  if (status === "REJECTED") {
    return {
      text: "Rejected",
      color: "#ff9999",
    }
  } else if (status === "PENDING") {
    return {
      text: "Pending",
      color: "#ffcc66",
    }
  } else if (status === "ACCEPTED") {
    return {
      text: "Accepted",
      color: "#66cc66",
    }
  } else if (status === "COMPLETED") {
    return {
      text: "Completed",
      color: "#66cc66",
    }
  } else if (status === "NOT_UPLOADED") {
    return {
      text: "Not Uploaded",
      color: "#272829",
    }
  } else {
    return {
      text: "Not Available",
      color: "#D9D9D9",
    }
  }
}

export const formatDiscountRoundOff = (discount) => {
  const rounded = Number(discount).toFixed(2);
  return rounded.endsWith('.00') ? parseInt(rounded) : parseFloat(rounded);
};

export const formatAmount = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'decimal',
    maximumFractionDigits: 2
  }).format(amount);
};

export const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60).toString().padStart(2, "0");
  const secs = (seconds % 60).toString().padStart(2, "0");
  return `${minutes}:${secs}`;
};

// export const copyText = (text, message) => {
//   const input = document.createElement("input");
//   input.setAttribute("readonly", "readonly");
//   input.setAttribute("value", text);
//   document.body.appendChild(input);
//   input.select();
//   input.setSelectionRange(0, 9999);
//   const copy = document.execCommand("Copy");
//   if (copy && message) {
//     document.execCommand("Copy");
//     // Toast.info(message, 2, undefined, false);
//   }
//   document.body.removeChild(input);
// };

// export const second2HHMMSS = (second) => {
//   let hours = Math.floor(second / 3600);
//   let minutes = Math.floor((second - hours * 3600) / 60);
//   let seconds = second - hours * 3600 - minutes * 60;

//   if (hours < 10) {
//     hours = "0" + hours;
//   }
//   if (minutes < 10) {
//     minutes = "0" + minutes;
//   }
//   if (seconds < 10) {
//     seconds = "0" + seconds;
//   }
//   return hours + ":" + minutes + ":" + seconds;
// };

// export function debounce(func, wait, immediate) {
//   let timeout;
//   return function (...args) {
//     //@ts-ignore
//     let context = this;
//     var later = function () {
//       timeout = null;
//       if (!immediate) func.apply(context, args);
//     };
//     var callNow = immediate && !timeout;
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//     if (callNow) func.apply(context, args);
//   };
// }

// export function throttle(callback, wait) {
//   let timeout = null;
//   let prevArgs = null;

//   //@ts-ignore
//   let context = this;
//   return (...args) => {
//     prevArgs = args;
//     if (!timeout) {
//       callback.apply(context, [...prevArgs]);
//       prevArgs = null;
//       timeout = setTimeout(() => {
//         timeout = null;
//         if (prevArgs) callback.apply(context, [...prevArgs]);
//         else callback.apply(context);
//       }, wait || 100);
//     }
//   };
// }
